import { Phone, PhoneCall } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../../data/content";

export const QuoteTeaser = () => (
  <section className="py-16 sm:py-20 border-b border-zinc-800/60" data-testid="quote-teaser-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="bg-gradient-to-r from-blue-600/15 to-transparent border border-blue-500/30 rounded-xl p-8 sm:p-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-start gap-4">
          <div className="bg-blue-600/10 border border-blue-500/20 rounded-sm p-3 shrink-0">
            <PhoneCall className="h-6 w-6 text-blue-500" />
          </div>
          <div>
            <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-white mb-2">
              Reliable Quotes Over the Phone
            </h2>
            <p className="text-zinc-400 leading-relaxed max-w-xl">
              Tell us your vehicle and the problem — we can generally give you a reliable
              quote right over the phone.
            </p>
          </div>
        </div>
        <a
          data-testid="quote-teaser-button"
          href={PHONE_TEL}
          className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white rounded-sm px-8 py-4 font-semibold transition-colors shrink-0"
        >
          <Phone className="h-5 w-5" /> Call {PHONE_DISPLAY}
        </a>
      </div>
    </div>
  </section>
);
